export const getAccountTransactions = (
  dispatch: any,
  account: string,
  token: string,
  dateRange: any[],
  querySize: number,
  maxResults: number
) =>
  dispatch({
    type: "GET_ACCOUNTTRANSACTIONS",
    account,
    token,
    dateRange,
    querySize,
    maxResults,
  });

export const getAccountTransactionsSuccess = (
  transactions: any[],
  token: string,
  dateRange: any[],
  total: number
) => ({
  type: "GET_ACCOUNTTRANSACTIONS_SUCCESS",
  transactions,
  token,
  dateRange,
  total,
});

export const getAccountTransactionsFailure = (error: Error) => ({
  type: "GET_ACCOUNTTRANSACTIONS_FAILURE",
  error,
});
